export type StopColors = {
  activeBg: string;
  activeIcon: string;

  ghostBg: string;
  ghostBgHover: string;
  ghostIcon: string;
  ghostBorder: string;

  focusBg: string;
  focusBgHover: string;
  focusIcon: string;
  focusBorder: string;
};

export function getStopColors(): StopColors {
  const fallback: StopColors = {
    activeBg: "#E10E1C",
    activeIcon: "#FFFFFF",

    ghostBg: "#F8F4F0",
    ghostBgHover: "#FFFFFF",
    ghostIcon: "#320010",
    ghostBorder: "#320010",

    focusBg: "#F8F4F0",
    focusBgHover: "#FFFFFF",
    focusIcon: "#320010",
    focusBorder: "#320010",
  };

  if (typeof window === "undefined") {
    return fallback;
  }

  const css = getComputedStyle(document.documentElement);

  const getVar = (name: string, fallbackValue: string) =>
    css.getPropertyValue(name).trim() || fallbackValue;

  return {
    activeBg: getVar("--button-primary-color-bg-active", fallback.activeBg),
    activeIcon: getVar("--button-text-color-primary", fallback.activeIcon),

    ghostBg: getVar("--button-ghost-color-bg", fallback.ghostBg),
    ghostBgHover: getVar(
      "--button-ghost-color-bg-hover",
      fallback.ghostBgHover
    ),
    ghostIcon: getVar("--button-ghost-color-icon", fallback.ghostIcon),
    ghostBorder: getVar("--button-ghost-color-border", fallback.ghostBorder),

    focusBg: getVar("--button-ghost-color-bg", fallback.focusBg),
    focusBgHover: getVar(
      "--button-ghost-color-bg-hover",
      fallback.focusBgHover
    ),
    focusIcon: getVar("--button-ghost-color-icon", fallback.focusIcon),
    focusBorder: getVar("--button-ghost-color-border", fallback.focusBorder),
  };
}
